import { get, post } from "./api";
import type {
  PendingSubmissionsPage,
  ResolveSubmissionRequest,
  SubmissionResponse,
  PlayerSubmissionRequest,
} from "../types/submissions";

const API_BASE_URL =
  import.meta.env.VITE_API_BASE_URL || "http://localhost:5206";

/**
 * The program behind a public form link, so the form can name whose it is. Anonymous, so it
 * bypasses the shared api client and its auth header.
 */
export const getPublicFormOrganization = async (
  orgToken: string
): Promise<{ organizationName: string }> => {
  const response = await fetch(`${API_BASE_URL}/api/public/${orgToken}`);
  if (!response.ok) throw new Error("Form not found");
  return response.json();
};

export const submitPlayerForm = async (
  orgToken: string,
  data: PlayerSubmissionRequest
): Promise<SubmissionResponse> => {
  const response = await fetch(
    `${API_BASE_URL}/api/public/${orgToken}/submit`,
    {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(data),
    }
  );

  if (!response.ok) {
    const errorData = await response.json().catch(() => ({}));
    throw new Error(
      (errorData as { message?: string }).message ||
        `Submission failed: ${response.status}`
    );
  }

  return response.json();
};

export const getPendingSubmissions = (
  pageNumber = 1,
  pageSize = 20
): Promise<PendingSubmissionsPage> =>
  get(`/api/crm/submissions/pending?pageNumber=${pageNumber}&pageSize=${pageSize}`);

export const resolveSubmission = (
  id: string,
  request: ResolveSubmissionRequest
): Promise<{ message: string }> =>
  post(`/api/crm/submissions/${id}/resolve`, request);

export const dismissSubmission = (id: string): Promise<{ message: string }> =>
  post(`/api/crm/submissions/${id}/dismiss`);
